import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { authApi } from "@/features/auth/api";
import { pendingActionsApi } from "@/features/self/pending/api/pendingActions";
import type { PendingActionItem } from "@/features/self/pending/types/pending.types";

export function createLeavePendingRemovalPatches(
  dispatch: ThunkDispatch<any, any, UnknownAction>,
  predicate: (item: PendingActionItem) => boolean,
) {
  const pendingListPatch = dispatch(
    pendingActionsApi.util.updateQueryData("getPendingActions", undefined, (draft) => {
      const idx = draft.items.findIndex(predicate);
      if (idx !== -1) {
        draft.items.splice(idx, 1);
        draft.summary.total_count = Math.max(0, draft.summary.total_count - 1);
      }
    }),
  );
  const pendingCountPatch = dispatch(
    authApi.util.updateQueryData("getPendingCount", undefined, (draft) => {
      if (draft.count > 0) draft.count -= 1;
    }),
  );
  return { pendingListPatch, pendingCountPatch };
}

export function leaveApprovalPredicate(id: number) {
  return function matchLeaveApproval(item: PendingActionItem): boolean {
    return (
      item.action_required === "approve_application" &&
      "period_start" in item.details &&
      (("leave_id" in item.details && item.details.leave_id === id) || item.id === id)
    );
  };
}
